import './App.css';
import { Barra } from './componentes/Barra';
import { Contenido } from './componentes/Contenido';
import { Footer } from './componentes/Footer';

function App() {
  return (
    <div className="App">
      <Barra />
      <Contenido />
      <Footer />
    </div>
  );
}

export default App;
